//@ts-ignore
import { v4 as uuidv4 } from 'uuid';
import { createLayer, setLayerSettings, setLayerVisible } from '../store/actions';
import { state } from '../store/state';
import { developDiagrams } from './patterns/developDiagrams';
import { wellsGtm } from './patterns/wellsGtm/wellsGtm';
import { wellsState } from './patterns/wellsState/wellsState';
import { wellsTransit } from './patterns/wellsTransit/wellsTransit';

import type { LayerPattern } from './patterns';
import { saveCurrentTemplate } from '../templates';
import { wellsSigns } from './patterns/wellSigns/wellSigns';
import { contours } from './patterns/contours/contours';
import { wellGroups } from './patterns/wellGroups';
import { miniGraphs } from './patterns/miniGraphs';
import { voronoi } from './patterns/voronoi';
import { userCircle } from './patterns/userCircle';

export interface Layer {
    guid: string;
    pattern: LayerPattern;
    title: string;
}

export const initSettings = async (layer: Layer) => {
    if (layer.pattern.settingsInit !== undefined) {
        const newFullSettings = layer.pattern.settingsInit();
        const newSettings: Record<string, unknown> = {};
        newFullSettings.forEach(s => {
            newSettings[s.key] = s.defaultValue;
        });
        await setLayerSettings(layer, newSettings);
    } else {
        if (layer.pattern.settings !== undefined) {
            const newSettings: Record<string, unknown> = {};
            layer.pattern.settings.forEach(s => {
                newSettings[s.key] = s.defaultValue;
            });
            await setLayerSettings(layer, newSettings);
        }
    }
};

export const setPatternLoaded = (patternKey: string): void => {
    state.loadedLayersData.add(patternKey);
    Array.from(state.layerStructure.values()).forEach(async layer => {
        if (layer.pattern.key === patternKey) {
            await initSettings(layer);
        }
    });
};

export const initLayer = async (
    pattern: LayerPattern,
    defaultVisible = false,
    title: string | undefined = undefined,
    defaultGuid: string | undefined = undefined,
): Promise<Layer> => {
    // подбираем незанятый title
    let newTitle = pattern.title;
    if (title !== undefined) {
        newTitle = title;
    } else {
        const busyTitles = new Set<string>(Array.from(state.layerStructure.values()).map(l => l.title));
        let i = 1;
        while (busyTitles.has(newTitle)) {
            newTitle = `${pattern.title} ${i}`;
            i++;
        }
    }

    const newLayer: Layer = {
        guid: defaultGuid ? defaultGuid : pattern.pinned ? pattern.key : uuidv4(),
        pattern,
        title: newTitle,
    };

    await createLayer(newLayer);
    await setLayerVisible(newLayer, defaultVisible);

    if (state.loadedLayersData.has(newLayer.pattern.key)) {
        await initSettings(newLayer);
    }

    return newLayer;
};

// Заменить на шаблон по умолчанию, когда доделаю систему шаблонов пользователя
export async function initBasicLayers() {
    await initLayer(wellsSigns, true, wellsSigns.title);

    saveCurrentTemplate('пустой шаблон');
    await initLayer(developDiagrams, false, developDiagrams.title);
    await initLayer(wellsGtm, false, wellsGtm.title);
    await initLayer(wellsTransit, false, wellsTransit.title, 'well_transit_v3');
    await initLayer(wellsState, false, wellsState.title);
    await initLayer(contours, false, contours.title);
    await initLayer(wellGroups, false, wellGroups.title);
    await initLayer(miniGraphs, false, miniGraphs.title);
    await initLayer(voronoi, false, voronoi.title);
    //initLayer(grid, false, grid.title);
    await initLayer(userCircle, true, userCircle.title);

    saveCurrentTemplate('тестовый шаблон');
}
